import { takeEvery, call, select, put, all } from 'redux-saga/effects';
import { CREATE_CATEGORY, REMOVE_CATEGORY, GET_CATEGOREIS, UPDATE_CATEGORY, REMOVE_PRODUCT } from 'store/actionTypes';
import { SetDocService, RemoveDocService, GetDocService } from 'store/services/document';
import { CategoryProducts } from 'store/selectors/products'
import { GetCollectionDocs } from 'store/services/collection';
import { FileUploadService, FileRemoveService } from 'store/services/file';
import { message } from 'antd';

//watchers 
export function* CreateCategoryWatcher() {
    yield takeEvery(CREATE_CATEGORY.WATCH, CreateCategoryWorker);
}

export function* UpdateCategoryWatcher() {
    yield takeEvery(UPDATE_CATEGORY.WATCH, UpdateCategoryWorker);
}

export function* RemoveCategoryWatcher() {
    yield takeEvery(REMOVE_CATEGORY.WATCH, RemoveCategoryWorker);
}

export function* GetCategoriesWatcher() {
    yield takeEvery(GET_CATEGOREIS.WATCH, GetCategoriesWorker);
}

// workers
function* CreateCategoryWorker({ payload, type }) {
    try {
        const { ref, data, files, collection, document } = payload;
        yield put({ type: CREATE_CATEGORY.LOAD });
        const fileResponse = yield call(FileUploadService, payload);
        const updatedData = { ref, collection, document, data: { ...data, file: fileResponse[0] } };
        yield call(SetDocService, updatedData);
        yield put({ type: CREATE_CATEGORY.SUCCESS, payload: updatedData });
        payload.cb && payload.cb();
        message.success('Категория создана');
    } catch (e) {
        message.error(e.message);
        yield put({ type: CREATE_CATEGORY.FAIL, payload: e.message });
    }
}


export function* UpdateCategoryWorker({ payload, type }) {
    try {
        const { ref, data, files, collection, document } = payload;
        yield put({ type: UPDATE_CATEGORY.LOAD });
        const fileResponse = files[0] && files[0].url ? null : yield call(FileUploadService, payload);
        const updatedData = { ref, collection, document, data: { ...data, file: fileResponse ? fileResponse[0] : files[0].url } };
        yield call(SetDocService, updatedData);
        yield put({ type: UPDATE_CATEGORY.SUCCESS, payload: updatedData });
        message.success(`Категория ${fileResponse ? 'добавлена' : 'обновлена'}`);
        payload.cb && payload.cb();
    } catch (e) {
        message.error(e.message);
        yield put({ type: UPDATE_CATEGORY.FAIL });
    }
}


function* RemoveCategoryWorker({ payload }) {
    try {
        yield put({ type: REMOVE_CATEGORY.LOAD });
        // select current category products
        const categoryProducts = yield select(state => CategoryProducts(state, payload.document));
        // remove current current category products
        const categoryProductsCall = categoryProducts.length && categoryProducts.map(it => call(RemoveDocService, { collection: 'products', document: it.id }));
        // dispatch remove succes action
        const categoryProductsPut = categoryProducts.length && categoryProducts.map(it => put({ type: REMOVE_PRODUCT.SUCCESS, payload: { collection: 'products', document: it.id } }));
        // remove current current category products image
        const imagesArray = categoryProducts.length ? [...categoryProducts, payload.category] : [payload.category];
        const categoryProductsImages = imagesArray.map(it => call(FileRemoveService, { ref: it.file }));
        // remove current category
        yield call(RemoveDocService, payload);
        // runn all actions
        yield all([...categoryProductsCall || [], ...categoryProductsPut || [], ...categoryProductsImages || []]);
        yield put({ type: REMOVE_CATEGORY.SUCCESS, payload });
        message.success('Категория удалена');
        payload.cb && payload.cb();
    } catch (e) {
        message.error(e.message);
        yield put({ type: REMOVE_CATEGORY.FAIL, payload: e.message });
    }
}

function* GetCategoriesWorker({ payload }) {
    try {
        yield put({ type: GET_CATEGOREIS.LOAD });
        const response = yield call(GetCollectionDocs, payload)
        yield put({ type: GET_CATEGOREIS.SUCCESS, payload: response });
    } catch (e) {
        message.error(e.message);
        yield put({ type: GET_CATEGOREIS.FAIL, payload: e.message });
    }
}